/**
 * @description Directory for ID Attributes (DataGrid).
 * Naming Convention: "[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "mainlayout-btn-cancel".
 */
const idDirectory = {
    dataGridActions: {
        divRoot: `dataGridActions-div-root`,
        btnColFilter: `dataGridActions-btn-colFilter`,
        btnCopy: `dataGridActions-btn-copy`,
        btnCSV: `dataGridActions-btn-CSV`,
        btnExcel: `dataGridActions-btn-excel`,
        btnExportAll: `dataGridActions-btn-exportAll`,
        btnExportAllXlsx: `dataGridActions-btn-exportAll`,
        btnPrint: `dataGridActions-btn-print`,
        btnColumn: `dataGridActions-btn-column`,
        btnSwitchGrid: `dataGridActions-btn-switch-grid`,
    },
    dataGridSlim: {
        divRoot: `dataGridSlim-div-root`,
        tableContainer: `dataGridSlim-table-container`,
        tableHead: `dataGridSlim-table-head`,
        tableHeadCell: `dataGridSlim-tableCell-header`,
    },
    dataGridSlimMTD: {
        divRoot: `dataGridSlimMTD-div-root`,
        tableContainer: `dataGridSlimMTD-table-container`,
        tableHeader: `dataGridSlimMTD-table-header`,
        tableHeaderCell: `dataGridSlimMTD-tableCell-header`,
        tableBody: `dataGridSlimMTD-table-body`,
        tableFooter: `dataGridSlimMTD-table-footer`,
        divEntries: `dataGridSlimMTD-div-entries`,
        tableCell: `dataGridSlimMTD-tableCell`,
    },
    dataGridEditable: {
        divRoot: `dataGridEditable-div-root`,
        tableContainer: `dataGridEditable-table-container`,
        tableHead: `dataGridEditable-table-head`,
        tableHeadCell: `dataGridEditable-tableCell-header`,
    },
}

export default idDirectory
